import React, { ReactNode } from "react";
import styled from "styled-components";
import { content } from "@glossy";

interface IProps {
  children: ReactNode;
  className?: string;
}

const StyledDescription = styled.p`
  color: ${(props) => content(props, "secondary")};
`;

const UiKitFormDescription = ({ children, className }: IProps) => (
  <StyledDescription className={className}>{children}</StyledDescription>
);

export default UiKitFormDescription;
